import { Engine } from "../Engine";
import { Mesh } from "./Mesh";
import { RenderObject } from "./RenderObject";

export class RenderObjectFactory {

    constructor(public engine: Engine) {
    }

    public instantiateMesh(mesh: Mesh): RenderObject {
        let obj = mesh.createInstance(this.engine.ctx);

        this.engine.activeScene.pickingManager.mapNext(obj);
        this.engine.activeScene.objectManager.addObject(obj);

        return obj;
    }

    public create(objectType: string): RenderObject {
        let mesh = this.engine.meshManager.getMesh(objectType);
        return this.instantiateMesh(mesh);
    }
}

